import getFetchOptions from 'utils/getFetchOptions';

import { handleResponse } from '../utils';
import {
  MerchantFileResponse,
  MerchantFileUploadCategory,
  MerchantFileUploadDocType,
  MerchantFileUploadResponse,
} from './files.types';

export const uploadMerchantFile = async (
  apiBaseUri: string,
  merchantId: string,
  category: MerchantFileUploadCategory,
  docType: MerchantFileUploadDocType,
  file: File,
): Promise<MerchantFileUploadResponse> => {
  const formData = new FormData();
  formData.append('category', category);
  formData.append('docType', docType);
  formData.append('file', file);

  const options = await getFetchOptions('POST', formData);

  return await fetch(`${apiBaseUri}/files/merchants/${merchantId}`, options).then(handleResponse);
};

export const getMerchantFile = async (
  apiBaseUri: string,
  merchantId: string,
  fileId: string,
): Promise<MerchantFileResponse> => {
  const options = await getFetchOptions('GET');

  return await fetch(`${apiBaseUri}/files/merchants/${merchantId}/files/${fileId}`, options).then(handleResponse);
};

export const downloadMerchantFile = async (
  apiBaseUri: string,
  merchantId: string,
  fileId: string,
): Promise<string | null> => {
  const options = await getFetchOptions('GET');
  return await fetch(`${apiBaseUri}/files/merchants/${merchantId}/files/${fileId}/download`, options)
    .then((res) => {
      return res.blob();
    })
    .then((blob) => URL.createObjectURL(blob))
    .catch((err) => {
      return null;
    });
};

export const uploadMerchantOnboardingFile = async (
  apiBaseUri: string,
  merchantId: string,
  docType: MerchantFileUploadDocType,
  file: File,
): Promise<MerchantFileUploadResponse> => {
  const formData = new FormData();
  formData.append('docType', docType);
  formData.append('file', file);

  const options = await getFetchOptions('POST', formData);

  return await fetch(`${apiBaseUri}/onboarding/files/merchants/${merchantId}`, options).then(handleResponse);
};
